/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import { TYPE_COMPONENT_BY_TYPE_ACTE } from '@/constants';

import InformationsConjoint from './InformationsConjoint';

interface StepConjointProps {
  numeroConjoint: 1 | 2;
}

/**
 * Étape « conjoint » d'un acte de mariage, paramétrée par le rang.
 *
 * Deux enveloppes sans prop l'exposent au registre `ASSISTANT_CONFIG`, qui monte
 * les composants d'étape sans leur passer d'argument.
 */
const StepConjoint = ({ numeroConjoint }: StepConjointProps) => {
  const { data, onChange, errors, selectedTypeActe } =
    React.useContext(AssistantContext);

  const step = numeroConjoint === 1 ? Steps.Conjoint1 : Steps.Conjoint2;

  /** Tranche d'erreurs propre à cette étape (clés = `name` sans préfixe). */
  const errorsStep = errors?.[step] ?? {};

  const typeComponent = selectedTypeActe
    ? TYPE_COMPONENT_BY_TYPE_ACTE[selectedTypeActe]
    : undefined;

  return (
    <div
      className={`assistant-step-conjoint${numeroConjoint}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsConjoint
        numeroConjoint={numeroConjoint}
        // La RACINE : les champs de lieu lisent leur valeur par chemin complet.
        data={data}
        dateMariage={data?.dateMariage}
        errors={errorsStep}
        onChange={onChange}
        typeComponent={typeComponent}
      />
    </div>
  );
};

export const StepConjoint1 = () => <StepConjoint numeroConjoint={1} />;
export const StepConjoint2 = () => <StepConjoint numeroConjoint={2} />;

export default StepConjoint;
